import React from 'react'
import { EIconName } from '@frontend/pole-ui/lib/components/Icon'
import classNames from 'classnames'
import { Button, Icon, Image } from '@/components/ui'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { LandingAnimation } from '../LandingAnimation'
import { LANDING_ANIMATION } from '../LandingAnimation/constants'
import { ELandingStepsAnimationDelay } from './constants'
import type { TLandingStepsProps } from './types'
import './styles.scss'

export const LandingSteps: React.FC<TLandingStepsProps> = ({
  title,
  image,
  steps,
  submitButtonText,
  className,
  withAnimation,
  onClickSubmitButton,
}) => {
  const { isDesktop } = useDeviceType()

  return (
    <section className={className}>
      <div className={classNames('landingSteps page-wrapper')}>
        <LandingAnimation
          desktopTargetStyles={{ ...LANDING_ANIMATION.fadeRight, delay: ELandingStepsAnimationDelay.TITLE }}
          isDisabled={!withAnimation}
        >
          <h2 className="landingSteps__title">{title}</h2>
        </LandingAnimation>
        {isDesktop && (
          <LandingAnimation
            desktopTargetStyles={{ ...LANDING_ANIMATION.fadeRight, delay: ELandingStepsAnimationDelay.ILLUSTRATION }}
            isDisabled={!withAnimation}
          >
            <div className="landingSteps__image">
              <Image src={image} shouldUseExactSrc />
            </div>
          </LandingAnimation>
        )}
        <LandingAnimation
          desktopTargetStyles={{
            ...LANDING_ANIMATION.fadeUp,
            delay: ELandingStepsAnimationDelay.STEPS,
          }}
          isDisabled={!withAnimation}
        >
          <ol className="landingSteps__steps">
            {steps.map((step, index) => (
              <li className="landingSteps__step">
                <div className="h5 landingSteps__stepIcon">
                  {index === steps.length - 1 ? <Icon name={EIconName.Ok2} /> : String(index + 1).padStart(2, '0')}
                </div>
                <div className="landingSteps__stepText">
                  <h3 className="landingSteps__stepTitle h4">{step.title}</h3>
                  {step.description && <div className="landingSteps__stepDescription text_small">{step.description}</div>}
                </div>
                {index === steps.length - 1 && (
                  <Button className="landingSteps__submitButton" modifiers={['green']} onClick={onClickSubmitButton}>
                    {submitButtonText}
                  </Button>
                )}
              </li>
            ))}
          </ol>
        </LandingAnimation>
      </div>
    </section>
  )
}
